<template>
  <div
    style="overflow-y: scroll; height: 430px; padding: 0 8px"
    element-loading-background="#F7F8FC"
    v-loading="loading"
  >
    <div v-for="campaign in campaigns" :key="campaign.title">
      <el-card
        shadow="hover"
        style="height: 120px; background-color: #fff; padding-bottom: 5px; margin-bottom: 15px; border: none;"
      >
        <span
          style="display:block; font-size: 1.2em; font-weight:bold; color: #000; margin-bottom: 10px"
          >{{ campaign.title }}</span
        >
        <span style="display:block; font-weight: light; margin-bottom: 12px">{{
          campaign.type
        }}</span>
        <span style="display:block; font-weight: light;">{{ campaign.date }}</span>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CampaignsTab',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    campaigns: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// CampaignsTab.vue?71d40566